/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

/**
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 */
export const environment = {
  production: false,
  clientId: 'd06de8e23d00b6c5dc1d',
  clientSecret: 'd1fed9ecd058a49c840b6e167bb455719da2aedc'
};
